module.exports = __webpack_public_path__ + "static/media/klemmeno-kalos-book-cover.13271318.jpg";